module.exports = __webpack_public_path__ + "static/mediaEvents-074f78141076f46a5ce147d2e1676e4e.png";